(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-review"] && !window.DesignMode) return;
  try {
     

var swiper = new Swiper(".reviewSlider", {
        spaceBetween: 50,
        slidesPerView: 3,
 		slidesPerGroup: 3,
        loopFillGroupWithBlank: true,
		loop:true,
		autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        speed:2500,
        navigation: {
          nextEl: ".review-next",
          prevEl: ".review-prev",
        },
  breakpoints: { 
      320: {  
        spaceBetween: 20,
        slidesPerView: 1,
slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        speed:2500,
autoHeight: true
      },
      768: {  
        spaceBetween: 50,
        slidesPerView: 3,
slidesPerGroup: 3,
        loopFillGroupWithBlank: true,
      },
      1280: { 
        spaceBetween: 50,
        slidesPerView: 3,
slidesPerGroup: 3,
        loopFillGroupWithBlank: true,
      }
    }
      });
    



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ins-gallery"] && !window.DesignMode) return;
  try {
    
var swiper2 = new Swiper(".thumbsSlider", {
    spaceBetween: 10,
    slidesPerView: 6,
    loop: true,
    autoplay: true,
    centeredSlides: true,
    watchSlidesProgress: false,
    navigation: {
        nextEl: ".thumb-next",
        prevEl: ".thumb-prev",
    },
    lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
    },
    breakpoints: {
        320: {
            spaceBetween: 10,
            slidesPerView: 2,
        },
        768: {
            spaceBetween: 10,
            slidesPerView: 3,
        },
        1280: {
            spaceBetween: 10,
            slidesPerView: 6,
        }
    }
});
var swiper2 = new Swiper(".popSlider", {
    spaceBetween: 10,
    autoHeight: false,
    lazy: {
        loadPrevNext: true,
    },
    navigation: {
        nextEl: ".pop-next",
        prevEl: ".pop-prev",
    },
    thumbs: {
        swiper: swiper2,
    },
});
$('.thumbsSlider .swiper-slide').on('click', function () {
    $('.popmask').show()
    $('.popSliderbox').show();
})
$('.popmask, #pop_ins_close').on('click', function () {
    $('.popmask').hide()
    // $('.popSliderbox').hide();
    $('.popSliderbox').hide();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
